import React from 'react'
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import {Link} from "react-router-dom"
import {FormSelect} from "react-bootstrap"
import {getPathBack} from "../functions";

export class HelpWindowClass extends React.Component {

    render() {

        const {lang, show, closeHandler, sendHandler} = this.props
        const themes = [['1', '1'], ['2', '2'], ['3', '3']]

        const changeNameHandler = () => {
            // todo
        }

        const changeSelectHandler = () => {
            // todo
        }

        return (
            <>
                <Modal id={"create-modal"} show={show}>
                    <Modal.Header>
                        <Modal.Title className={'w-100 text-center'}>{'Title'}</Modal.Title>
                        <div className={'d-flex align-items-start'}>
                            <Link to={`/${lang.lang}/`}>
                                <Button className={'ms-2'} variant={"close"} onClick={closeHandler}/>
                            </Link>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <form className={'was-validated'}>
                            <fieldset className={'teal'}>
                                <label className={'form-label mt-3 mb-1'}>
                                    {'label'}
                                </label>
                                <input autoComplete={"off"}
                                       id={'input-1'}
                                       className={'inputs-1 form-control is-invalid'}
                                       placeholder={'placeholder'}
                                       onChange={changeNameHandler}
                                       defaultValue={''}
                                       required={true}
                                />
                                <label className={'form-label mt-3 mb-1'}>
                                    {'label'}
                                </label>
                                <input autoComplete={"off"}
                                       id={'input-2'}
                                       className={'inputs-value form-control is-invalid'}
                                       placeholder={'placeholder'}
                                       defaultValue={''}
                                       required={true}
                                />
                                <label className={'form-label mt-3 mb-1'}>
                                    {'label'}
                                </label>
                                <FormSelect id={'select-1'}
                                            className={'inputs-3 form-control is-invalid'}
                                            onChange={changeSelectHandler}
                                            defaultValue={'0'}
                                            required={true}>
                                    {themes.map((them, index) => {
                                        return <option value={them[0]} key={index}>{them[1]}</option>
                                    })}
                                </FormSelect>
                                <label className={'form-label mt-3 mb-1'}>
                                    {'label'}
                                </label>
                                <input autoComplete={"off"}
                                       id={'input-3'}
                                       className={'form-control is-invalid text-start'}
                                       defaultValue={'defaultValue'}
                                       placeholder={'placeholder'}
                                       required={true}
                                />
                            </fieldset>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant={'success'}
                            onClick={sendHandler}>
                            {lang.modal.buttons.btnToOK}
                        </Button>
                        <Link to={getPathBack()}>
                            <Button variant={'secondary'}>
                                {lang.modal.buttons.btnToCancel}
                            </Button>
                        </Link>

                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}